export default __webpack_public_path__ + "static/media/favicon.f6e24238.svg";